import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Use sessionStorage for the auth session so it is cleared when the tab/window
// is closed: closing the screen ends the session and a new login is required.
// (Falls back to default storage in non-browser/test environments.)
const storage =
  typeof window !== "undefined" && window.sessionStorage ? window.sessionStorage : undefined;

const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    storage,
    persistSession: true,
    autoRefreshToken: true,
  },
});

export default supabase;
